module.exports = __webpack_public_path__ + "img/forest.f499eb82.jpeg";